/*
Device Detection
@package cfhof
Updated Version: 1.0
*/

function is_touch_enabled() {
    return ( 'ontouchstart' in window ) ||
           ( navigator.maxTouchPoints > 0 ) ||
           ( navigator.msMaxTouchPoints > 0 );
}

if( is_touch_enabled() ) {
    document.documentElement.classList.add('touch');
}